module.exports = __webpack_public_path__ + "img/bean-and-macaroni-soup.33fa854f.jpg";